export const configs = {
	appUrl: process.env.VUE_APP_FRONTEND,
	appCode: process.env.VUE_APP_CODE,
	apiGateway: process.env.VUE_APP_API_GATEWAY,
	aesKey: process.env.VUE_APP_KEY_AES,
	services : {
		auth: process.env.VUE_APP_API_GATEWAY + '/srv-auth',
        eligibility: process.env.VUE_APP_API_GATEWAY + '/srv-lead/public/fintos-website-eligibility',
		calculator: process.env.VUE_APP_API_GATEWAY + '/calculator/',
        send_otp: process.env.VUE_APP_API_GATEWAY + '/srv-lead/public/fintos-website-eligibility/otp',
        validate_otp: process.env.VUE_APP_API_GATEWAY + '/srv-lead/public/fintos-website-eligibility/validate-otp',
        // eligibility_form_check: process.env.VUE_APP_API_GATEWAY + '/srv-customer/public/customer.from_fintos',
        eligibility_form_check: 'https://gateway-demo.fintos.com.my/srv-customer/public/customer.from_fintos',
		access_control: process.env.VUE_APP_API_GATEWAY + '/srv-access-control',
		attachment: process.env.VUE_APP_API_GATEWAY + '/srv-attachment',
		customer: process.env.VUE_APP_API_GATEWAY + '/srv-customer',
		financial_proposal: process.env.VUE_APP_API_GATEWAY + '/srv-financial-proposal',
		lookup: process.env.VUE_APP_API_GATEWAY + '/srv-lookup',
		hub: process.env.VUE_APP_API_GATEWAY + '/srv-hub',
		lead: process.env.VUE_APP_API_GATEWAY + '/srv-lead',
		commitment:  process.env.VUE_APP_API_GATEWAY + '/srv-credit-report',
		messaging:  process.env.VUE_APP_API_GATEWAY + '/srv-message',
		esign:  process.env.VUE_APP_API_GATEWAY + '/srv-esign',
		product:  process.env.VUE_APP_API_GATEWAY + '/srv-product',
		approval:  process.env.VUE_APP_API_GATEWAY + '/srv-approval',
		notification:  process.env.VUE_APP_API_GATEWAY + '/srv-notification',
		initial_proposal: process.env.VUE_APP_API_GATEWAY + '/srv-proposal',
		billing: process.env.VUE_APP_API_GATEWAY + '/srv-billing',
		commission: process.env.VUE_APP_API_GATEWAY + '/srv-commission',
		fintos_calculator: 'https://api.imortgage2u.com/fintos/calculator',
		calculator: 'https://api-calculator.fintos.com.my',
		property: process.env.VUE_APP_API_GATEWAY + '/srv-hestia',
		// eligibility: process.env.VUE_APP_API_GATEWAY + '/srv-lead/public/fintos-website-eligibility',
		eligibility: 'https://gateway.fintos.com.my/srv-lead/public/fintos-website-eligibility',
		calculator: 'https://gateway.fintos.com.my/calculator/',
		send_otp: process.env.VUE_APP_API_GATEWAY + '/public/fintos-website-eligibility/otp',
	},
	endPoint : {
		access_control: {
			login: '/login',
			refresh: '/refresh',
			user_info: '/active-user-detail',
		}
	}
}